/* yy-header.js - dropdown, search overlay, mobile drawer, sticky scroll */
(function () {
  'use strict';

  const hd = document.querySelector('[data-yy-header]');
  if (!hd) return;

  /* -- Sticky scroll -- */
  const onScroll = () => hd.toggleAttribute('data-scrolled', window.scrollY > 10);
  window.addEventListener('scroll', onScroll, { passive: true });

  /* ------------------------------------------------------------------
     Dropdowns - CLICK TO OPEN, CLICK TO CLOSE.

     This used to close on `mouseleave` of the nav item, while only opening
     on click. That combination made the menu unusable: the panel sits 8px
     below the button (top: calc(100% + 8px) in yy-header.css), so moving the
     pointer down towards the menu crossed a gap that is outside the item,
     fired mouseleave, and shut the panel before it could be reached.

     Hover-close is now gone entirely. An open panel stays open until the
     person clicks the button again, clicks a link inside it, clicks
     anywhere else on the page, or presses Escape. That also makes it behave
     the same on touch, where mouseleave never fires reliably.

     If hover-to-open is ever wanted back, do NOT reintroduce a plain
     mouseleave - it needs a close delay plus a transparent bridge across
     that 8px gap, or this exact bug returns.
     ------------------------------------------------------------------ */
  const drops = [];

  hd.querySelectorAll('[data-yy-drop]').forEach(item => {
    const btn  = item.querySelector('.yy-hd__link');
    const drop = item.querySelector('.yy-hd__drop');
    if (!btn || !drop) return;

    const api = {
      item: item,
      btn: btn,
      drop: drop,
      isOpen: () => item.classList.contains('is-open'),
      open() {
        closeAll(api);
        drop.hidden = false;
        // Next frame, so the opacity/transform transition actually runs -
        // unhiding and adding the class in the same frame skips it.
        requestAnimationFrame(() => item.classList.add('is-open'));
        btn.setAttribute('aria-expanded', 'true');
      },
      close() {
        item.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
        drop.hidden = true;
      }
    };
    drops.push(api);

    btn.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();
      api.isOpen() ? api.close() : api.open();
    });

    // Clicking a link inside closes the panel. The navigation handles the
    // rest, but this matters for same-page anchors, and it stops the panel
    // hanging around if the person comes back via the browser's back button.
    drop.addEventListener('click', e => {
      if (e.target.closest('a')) api.close();
    });
  });

  function closeAll(except) {
    drops.forEach(d => { if (d !== except) d.close(); });
  }

  // Any click outside the nav closes whatever is open.
  document.addEventListener('click', e => {
    if (!e.target.closest('[data-yy-drop]')) closeAll();
  });

  // Escape closes and puts focus back on the button that opened it.
  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    const open = drops.find(d => d.isOpen());
    if (open) { open.close(); open.btn.focus(); }
  });

  /* -- Search overlay -- */
  const searchOverlay = hd.querySelector('[data-yy-search]');
  const openSearchBtns  = hd.querySelectorAll('[data-yy-search-open]');
  const closeSearchBtns = hd.querySelectorAll('[data-yy-search-close]');

  if (searchOverlay) {
    openSearchBtns.forEach(b => b.addEventListener('click', () => {
      searchOverlay.hidden = false;
      document.body.style.overflow = 'hidden';
      searchOverlay.querySelector('input')?.focus();
    }));
    closeSearchBtns.forEach(b => b.addEventListener('click', closeSearch));
    searchOverlay.addEventListener('click', e => {
      if (e.target === searchOverlay) closeSearch();
    });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && !searchOverlay.hidden) closeSearch();
    });
  }
  function closeSearch() {
    if (searchOverlay) { searchOverlay.hidden = true; document.body.style.overflow = ''; }
  }

  /* -- Mobile drawer -- */
  const drawer = hd.querySelector('[data-yy-drawer]');
  const openDrawerBtns  = hd.querySelectorAll('[data-yy-drawer-open]');
  const closeDrawerBtns = hd.querySelectorAll('[data-yy-drawer-close]');
  const burger = hd.querySelector('[data-yy-drawer-open]');

  if (drawer) {
    openDrawerBtns.forEach(b => b.addEventListener('click', openDrawer));
    closeDrawerBtns.forEach(b => b.addEventListener('click', closeDrawer));
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && !drawer.hidden) closeDrawer();
    });
  }
  function openDrawer() {
    if (!drawer) return;
    drawer.hidden = false;
    document.body.style.overflow = 'hidden';
    if (burger) burger.setAttribute('aria-expanded', 'true');
    drawer.querySelector('a, button')?.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.hidden = true;
    document.body.style.overflow = '';
    if (burger) burger.setAttribute('aria-expanded', 'false');
  }

  /* -- Cart open (dispatches event for the cart drawer section) -- */
  hd.querySelectorAll('[data-yy-cart-open]').forEach(b => {
    b.addEventListener('click', () => document.dispatchEvent(new CustomEvent('yy:cart:open')));
  });

})();
